import img from '@/assets/bottle-glass.png'
import img_1 from '@/assets/bottles.png'
import img_2 from '@/assets/degustation.jpg'
import img_3 from '@/assets/empty-star.png'
import img_4 from '@/assets/empty-star@2x.png'
import img_5 from '@/assets/empty-star@3x.png'
import img_6 from '@/assets/full-star.png'
import img_7 from '@/assets/full-star@2x.png'
import img_8 from '@/assets/full-star@3x.png'
import img_9 from '@/assets/gift.png'
import img_10 from '@/assets/input-valid-check-mark.png'
import img_11 from '@/assets/input-valid-check-mark@2x.png'
import img_12 from '@/assets/input-valid-check-mark@3x.png'
import img_13 from '@/assets/light.png'
import img_14 from '@/assets/light@2x.png'
import img_15 from '@/assets/light@3x.png'
import img_16 from '@/assets/logo.png'
import img_17 from '@/assets/masterclass_couple.jpg'
import img_18 from '@/assets/masterclass_female.jpg'
import img_19 from '@/assets/masterclass_male.jpg'
import img_20 from '@/assets/minus.svg'
import img_21 from '@/assets/modify.png'
import img_22 from '@/assets/plus.svg'
import img_23 from '@/assets/progression.jpg'
import img_24 from '@/assets/quizz.jpg'
import img_25 from '@/assets/splash-logo.png'
import img_26 from '@/assets/tasting.png'
import img_27 from '@/assets/vinsfavoris.jpg'

const staticAssets = [
  img,
  img_1,
  img_2,
  img_3,
  img_4,
  img_5,
  img_6,
  img_7,
  img_8,
  img_9,
  img_10,
  img_11,
  img_12,
  img_13,
  img_14,
  img_15,
  img_16,
  img_17,
  img_18,
  img_19,
  img_20,
  img_21,
  img_22,
  img_23,
  img_24,
  img_25,
  img_26,
  img_27
]

staticAssets.forEach(img => {
  const image = new Image()
  image.src = img
})
